import { AnchorLink } from '@/ui/components/ui/anchor-link'

import { MenuVariant } from '@/types/menu.types'
import { menuConfig } from '@/ui/components/navbar/config'

export function DesktopMenu({ variant }: { variant: MenuVariant }) {
  const config = menuConfig[variant]

  if (!config) {
    return null
  }

  const isDark = config.tone === 'dark'

  return (
    <ul
      className={`hidden desktop:flex items-center gap-10 ${
        isDark ? 'text-chalk/75' : 'text-anthracite'
      }`}
    >
      {config.links.map((link) => (
        <li key={link.href}>
          <AnchorLink
            aria-label={link.ariaLabel}
            href={link.href}
            title={link.title}
            className={`link-draw font-mono text-[0.6875rem] uppercase tracking-[0.16em] transition-colors ${
              isDark ? 'hover:text-chalk' : 'hover:text-ink'
            }`}
          >
            {link.label}
          </AnchorLink>
        </li>
      ))}
    </ul>
  )
}
